import { render, staticRenderFns } from "./w-pagination.vue?vue&type=template&id=a426a3ea"
import script from "./w-pagination.vue?vue&type=script&lang=js"
export * from "./w-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports